import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'app-order-buttons[array][index]',
  templateUrl: './order-buttons.component.html',
  styleUrls: ['./order-buttons.component.scss'],
  host: { '[class.vertical]': 'vertical' }
})
export class OrderButtonsComponent implements OnInit {
  @Input() array!: any[] | FormArray;
  @Input() index!: number;
  @Input() vertical = true;
  @Input() disabled = false;
  @Output() shifted = new EventEmitter<void>();

  public get first() { return this.index == 0; } // prettier-ignore
  public get last() { return this.index == this.array.length - 1;} // prettier-ignore

  constructor() {}

  ngOnInit(): void {}

  public shift(newIndex: number): void {
    if (this.disabled || newIndex === this.index) return;

    if (this.array instanceof FormArray) {
      const element = this.array.at(this.index);
      this.array.removeAt(this.index);
      this.array.insert(newIndex, element);
    } else {
      const element = this.array[this.index];
      this.array.splice(this.index, 1);
      this.array.splice(newIndex, 0, element);
    }

    this.shifted.emit();
  }
}
